import { Incarico } from './incarico';
import { Model } from './model';

export class StatoRiparazione extends Model {
  static apiUrl: string = "stati_riparazione";

  nome: string;

  incarichi: Incarico[];

  deserialize(input: any): StatoRiparazione {
    let retV: StatoRiparazione = new StatoRiparazione();
    retV = super.deserialize(input) as StatoRiparazione;

    if (input?.incarichi) {
      retV.incarichi = input.incarichi.map(m => new Incarico().deserialize(m));
    }

    return retV;
  }

}
